// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__3sHrS","footer":"Footer_footer__3vU6C"};